module.exports = __webpack_public_path__ + "img/union.e249e143.svg";